import { Box, Typography } from "@mui/material";

import { Tag } from "../../../../../../../types/types";

const PostDescriptionAndDetails = ({ description, tags }: { description?: string; tags?: Tag[] }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        padding: "0 16px",
      }}
    >
      {description && (
        <Typography
          sx={{
            color: "var(--Dark---1000, #111)",
            fontFamily: "Montserrat",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "20px",
          }}
        >
          {description}
        </Typography>
      )}

      {tags && tags?.length > 0 && (
        <Box sx={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
          {tags?.map(({ id, title }) => (
            <Typography
              key={id}
              sx={{
                color: "var(--Green---100, #008B07)",
                fontFamily: "Montserrat",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "20px",
              }}
            >
              #{title}
            </Typography>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default PostDescriptionAndDetails;
